import React from "react";
import { db } from "../db/state";
import { useValue } from "../lib/db/react";

type Props = React.HTMLAttributes<HTMLDivElement> & {
  ready?: boolean;
};

const Backdrop: React.FC<Props> = ({
  children,
  ready = true,
  style = {},
  ...rest
}) => {
  const [show, setShow] = React.useState(false);
  React.useEffect(() => {
    setShow(ready);
  }, [ready]);

  const focus = useValue(db, "focus");
  const background = useValue(db, "background");
  const { blur = 0, luminosity = 0 } = background.display;

  style = { ...style };

  if (!focus) {
    const filters: string[] = [];

    if (blur > 0) {
      filters.push(`blur(${blur}px)`);
      style["transform"] = `scale(${blur / 500 + 1})`;
    }

    if (luminosity !== 0) {
      const brightness = Math.max(0.15, 1 + luminosity);
      filters.push(`brightness(${brightness})`);
    }

    if (filters.length > 0) {
      style["filter"] = filters.join(" ");
    }
  }

  return (
    <div
      className="fullscreen"
      style={{
        opacity: show ? 1 : 0,
        transition: "opacity 150ms ease-in-out",
      }}
    >
      <div style={style} {...rest}>
        {children}
      </div>
    </div>
  );
};

export default Backdrop;
